
<template>
  <div class="row text-left justify-content-center">
    <div class="col-12 col-md-10 col-xl-8 rules">
      <h1 class="my-4">Rules<img :src="require('@/assets/images/icons/menu/rules.png')"/></h1>
      <div>
        <h1>Purchasing Stats/Skills</h1>
        <p>This is for Adventuring Skills, Combat Skills and Base Stats
          <ul>
            <li>For Ranks 1-5: Base Cost</li>
            <li>For Ranks 6-7: Base Cost + 1,000</li>
            <li>For Ranks 8-9: Base Cost + 2,000</li>
            <li>For Ranks 10-12: Base Cost + 3,000</li>
            <li>For Ranks 13-15: Base Cost + 4,000</li>
            <li>For Ranks 16-18: Base Cost + 5,000</li>
            <li>For Ranks 19-20: Base Cost + 6,000</li>
          </ul>
        </p>
      </div>
      <div>
        <h1>Learning Spells</h1>
        <p>
          In order to learn a spell in a certain school of magic, you must first learn the requisite caster proficiency and all other prerequisites. To obtain a higher rank of a spell, you must first learn the caster proficiency of the same rank. This stops applying once you get caster proficiency rank 10 for that school of magic.
        </p>
        <p>
          For example: If you want to learn Fire Bolt Rank 2, you must first get Fire Caster Proficiency Rank 2. If you want to learn Fire Ball Rank 6, you must first get Fire Caster Proficiency Rank 6.
        </p>
      </div>
      <div>
        <h1>Purchasing Spells</h1>
        <p>Base ability cost for purchasing spells. (-1,000 XP for Sorcerers)</p>
      </div>
      <div>
        <h1>Casting Spells</h1>
        <p>
          First you must roll a d20 to determine if your spellcast is successful. Add your Focus bonus to the result of the roll and any other bonuses. If that value exceeds the Focus DC on the spell, the cast is successful. If the spell is ranged, subtract 1/2 of the target's agility from your total roll, if it still exceeds the Focus DC it hits the target, if not, the spell misses the target.
        </p>
        <p>Cast range = 15 feet x 5 per Focus</p>
        <ul><u>Example Scenario</u>
          <li>Fire Bolt Rank 1 Focus DC: 10</li>
          <li>You make a d20 roll. Your d20 Roll = 8</li>
          <li>Add your Focus bonus, which is 3, to your roll. 3 + 8 = 11</li>
          <li>Subtract 1/2 of the target's agility, in this case 0</li>
          <li>Your total score would be 8 + 3 - 0 = 11. Since 11 > 10 the spell hits the target.</li>
        </ul>
      </div>
      <div>
        <h1>Focus & Damage</h1>
        <p>
          For caster proficiency ranks 1 - 3 of a certain school of magic, spellcasters may add 1/2 of their Focus to their damage.
        </p>
        <p>
          For caster proficiency ranks 4 and up or a certain school of magic, spellcasters may add their full Focus to their damage.
        </p>
        <p>
          This applies for each individual school of magic you know. Getting to caster proficiency rank 4 of fire does not allow you to apply your full Focus to a wind spell.
        </p>
      </div>
      <div>
        <h1>Lifting and Carrying</h1>
        <p>Your Strength rank determines the amount of weight you can lift or carry.</p>
        <h5>Carrying Capacity</h5>
        <p>
          Your carrying capacity is your Strength rank multiplied by 15 (minimum of 75 pounds). This is the weight (in pounds) that you can carry, which is high enough that most characters don't usually have to worry about it.
        </p>
        <h5>Push, Drag, or Lift</h5>
        <p>
          You can push, drag, or lift a weight in pounds up to twice your carrying capacity (or 30 times your Strength score, minimum of 150 pounds). While pushing or dragging weight in excess of your carrying capacity, your speed drops to 5 feet.
        </p>
        <h5>Size and Strength</h5>
        <p>
          Larger creatures can bear more weight, whereas Tiny creatures can carry less. For each size category above Medium, double the creature's carrying capacity and the amount it can push, drag, or lift. For each size category below Medium, halve these weights.
        </p>
      </div>
      <div>
        <h1>Dual Wielding Melee Weapons</h1>
        <p>
          Players can dual wield weapons, but due to its awkward nature, incurs a steep penalty for those who do not specialize in it.
        </p>
        <p>
          Dual wielding weapons causes the user to suffer a -8 penalty to all attack rolls. Learning the Ambidexterity feat reduces this penalty to -4 to all attack rolls. Your offhand attacks also only deal 1/2 damage. Bonus spell, focus, strength or ability damage on a weapon is only applied if you are using that weapon to make the melee strike or conjure the spell.
        </p>
        <p>
          While dual wielding, you may make a melee strike with both weapons during the same action, but you must make separate attack rolls for each weapon, suffering any penalties for each attack roll made.
        </p>
        <p>
          Strength multipliers made with your offhand weapon are capped at x1 strength.
        </p>
      </div>
    </div>
  </div>
</template>
<style>
.rules > h2 {
  margin-top: 20px;
}
.caster {
  color: #32a8a6;
}
</style>
<script>

export default {
  name: 'RulesPage',
  props: {
    app: Object
  },
  computed: {
  }
}
</script>
